import dayjs from 'dayjs';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import OptimizeTag from '@/components/meta/OptimizeTag';
import LpTemplate from '@/components/templates/Lp/Entry';
import { INVITER_PARAM_KEY } from '@/config/constants/query';
import useClock from '@/hooks/date/useClock';
import { setInviterCookie } from '@/lib/invitation';

const LpPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviter = queryParams.get(INVITER_PARAM_KEY);

  if (inviter) {
    setInviterCookie(inviter);
  }

  const currentTime = useClock();
  const isChargeBounsCp = React.useMemo(() => {
    const since = dayjs(import.meta.env.VITE_TORETA_BOUNS_CAMPAIGN_SINCE);
    const until = dayjs(import.meta.env.VITE_TORETA_BOUNS_CAMPAIGN_UNTIL);

    if (since && until) {
      return (
        since.unix() < currentTime.unix() && currentTime.unix() < until.unix()
      );
    }

    return false;
  }, [currentTime]);

  const title = React.useMemo(() => {
    return isChargeBounsCp
      ? '新規登録＋ミッション達成で最大5,000円分ポイントプレゼント！'
      : '新規登録＋ミッション達成で最大4,000円分ポイントプレゼント！';
  }, [isChargeBounsCp]);

  const description = React.useMemo(() => {
    return isChargeBounsCp
      ? `新規登録＋ミッション達成で最大5,000円分ポイントプレゼント！%s`
      : `新規登録＋ミッション達成で最大4,000円分ポイントプレゼント！%s`;
  }, [isChargeBounsCp]);

  const ogImagePath = React.useMemo(() => {
    return isChargeBounsCp
      ? `${import.meta.env.VITE_BASE_URL}/images/ogp/lp_ogp_5000.png`
      : `${import.meta.env.VITE_BASE_URL}/images/ogp/lp_ogp_4000.png`;
  }, [isChargeBounsCp]);

  return (
    <>
      <Helmet
        meta={{
          title,
          description,
          keywords: `新規登録,ポイントプレゼント,%s`,
          'og:image': ogImagePath,
        }}
      />
      <OptimizeTag />
      <LpTemplate inviter={inviter} isChargeBounsCp={isChargeBounsCp} />
    </>
  );
};

export default LpPage;
